import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { SolucionesPage } from './pages/SolucionesPage';
import { PlataformasPage } from './pages/PlataformasPage';
import { SobreNosotrosPage } from './pages/SobreNosotrosPage';
import { ProximosEventosPage } from './pages/ProximosEventosPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { CookiesPolicyPage } from './pages/CookiesPolicyPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/soluciones" element={<SolucionesPage data-id="element-5" />} data-id="element-4" />
        <Route path="/plataformas" element={<PlataformasPage data-id="element-7" />} data-id="element-6" />
        <Route path="/sobre-nosotros" element={<SobreNosotrosPage data-id="element-9" />} data-id="element-8" />
        <Route path="/proximos-eventos" element={<ProximosEventosPage data-id="element-11" />} data-id="element-10" />
        <Route path="/privacidad" element={<PrivacyPolicyPage data-id="element-13" />} data-id="element-12" />
        <Route path="/terminos" element={<TermsOfUsePage data-id="element-15" />} data-id="element-14" />
        <Route path="/cookies" element={<CookiesPolicyPage data-id="element-17" />} data-id="element-16" />
      </Routes>
    </Router>;
}